import type { ReactNode } from 'react'

import { AudioHeroLayout, HeroCover } from '../audio-hero-layout/AudioHeroLayout'

import styles from './AudioHero.module.css'

type TAudioHeroProps = {
    coverSrc: string
    /** Both set by the served template, which picks between cover and placeholder in PHP. */
    backgroundSlot?: ReactNode
    coverSlot?: ReactNode
    title: string
    playbackSlot: ReactNode
    /** Mobile/tablet-only top row (the owner's more-actions trigger); hidden on desktop by its own CSS. */
    mobileHeaderSlot?: ReactNode
    /** Centered mobile controls (share / play / like) below the waveform; desktop uses side play + bar. */
    mobileControlsSlot?: ReactNode
    /** Full-width download shown on mobile/tablet only; desktop keeps download inside the bar. */
    mobileDownloadSlot?: ReactNode
    heroBarSlot: ReactNode
    bottomSlot?: ReactNode
}

export const AudioHero = ({
    coverSrc,
    backgroundSlot,
    coverSlot,
    title,
    playbackSlot,
    mobileHeaderSlot,
    mobileControlsSlot,
    mobileDownloadSlot,
    heroBarSlot,
    bottomSlot,
}: TAudioHeroProps) => (
    <AudioHeroLayout coverUrl={coverSrc} backgroundSlot={backgroundSlot}>
        {mobileHeaderSlot}
        <div className={styles.center}>
            <div className={styles.cover}>
                {coverSlot ?? <HeroCover src={coverSrc} alt={title} />}
            </div>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.playback}>{playbackSlot}</div>
            {mobileControlsSlot ? (
                <div className={styles.mobileControls}>{mobileControlsSlot}</div>
            ) : null}
        </div>
        <div className={styles.barSection}>
            {mobileDownloadSlot ? (
                <div className={styles.mobileDownload}>{mobileDownloadSlot}</div>
            ) : null}
            <div className={styles.bar}>{heroBarSlot}</div>
        </div>
        {bottomSlot}
    </AudioHeroLayout>
)
